(()=>{
  const init=()=>{
    const root=document.documentElement;
    if(root.dataset.akgMenuReady==='1')return;
    const trigger=document.querySelector('[data-akg-menu-trigger]');
    const menu=document.getElementById('ak-global-menu');
    if(!trigger||!menu)return;
    const panel=menu.querySelector('.akg-panel');
    const html=document.documentElement;
    const body=document.body;
    const reduce=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
    let open=false,lastFocus=null,lockY=0,closeTimer=0;
    let backgroundState=[];
    const backgroundTargets=()=>Array.from(new Set(Array.from(document.querySelectorAll('#MainContent, main, [data-ak-global-footer], footer')))).filter(el=>el&&!menu.contains(el));
    const isolateBackground=()=>{
      backgroundState=backgroundTargets().map(el=>({el,hadInert:el.hasAttribute('inert'),ariaHidden:el.getAttribute('aria-hidden')}));
      backgroundState.forEach(({el})=>{el.setAttribute('inert','');el.setAttribute('aria-hidden','true');});
    };
    const restoreBackground=()=>{
      backgroundState.forEach(({el,hadInert,ariaHidden})=>{
        if(!hadInert)el.removeAttribute('inert');
        if(ariaHidden===null)el.removeAttribute('aria-hidden');else el.setAttribute('aria-hidden',ariaHidden);
      });
      backgroundState=[];
    };
    let bodyState=null;
    const focusables=()=>Array.from(menu.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]')).filter(el=>!el.hidden&&el.offsetParent!==null&&el.tabIndex>=0);
    const lockScroll=()=>{
      lockY=window.scrollY||window.pageYOffset||0;
      bodyState={position:body.style.position,top:body.style.top,left:body.style.left,right:body.style.right,width:body.style.width,overflow:body.style.overflow};
      body.style.position='fixed';body.style.top=`-${lockY}px`;body.style.left='0';body.style.right='0';body.style.width='100%';body.style.overflow='hidden';
      html.classList.add('akg-menu-open');body.classList.add('akg-menu-open');
    };
    const unlockScroll=()=>{
      if(bodyState){Object.assign(body.style,bodyState);bodyState=null;}
      html.classList.remove('akg-menu-open');body.classList.remove('akg-menu-open');
      window.scrollTo(0,lockY);
    };
    const finishClose=(restoreFocus=true)=>{
      menu.hidden=true;menu.setAttribute('aria-hidden','true');
      restoreBackground();
      if(restoreFocus&&lastFocus&&typeof lastFocus.focus==='function')lastFocus.focus({preventScroll:true});
    };
    const closeMenu=(restoreFocus=true)=>{
      if(!open)return;
      open=false;clearTimeout(closeTimer);
      trigger.setAttribute('aria-expanded','false');
      trigger.setAttribute('aria-label',trigger.dataset.labelOpen||'Open menu');
      menu.classList.remove('is-open');
      unlockScroll();
      if(reduce())finishClose(restoreFocus);else closeTimer=setTimeout(()=>finishClose(restoreFocus),320);
    };
    const openMenu=()=>{
      if(open)return;
      open=true;clearTimeout(closeTimer);lastFocus=document.activeElement;
      menu.hidden=false;menu.setAttribute('aria-hidden','false');
      isolateBackground();
      trigger.setAttribute('aria-expanded','true');
      trigger.setAttribute('aria-label',trigger.dataset.labelClose||'Close menu');
      lockScroll();
      requestAnimationFrame(()=>requestAnimationFrame(()=>{
        menu.classList.add('is-open');
        if(panel)panel.focus({preventScroll:true});
      }));
    };
    trigger.addEventListener('click',()=>open?closeMenu(true):openMenu());
    menu.querySelectorAll('[data-akg-close]').forEach(el=>el.addEventListener('click',()=>closeMenu(true)));
    menu.addEventListener('click',event=>{
      const link=event.target.closest('a[href]');
      if(!link||!menu.contains(link))return;
      closeMenu(false);
    });
    menu.querySelectorAll('form').forEach(form=>form.addEventListener('submit',()=>closeMenu(false)));
    document.addEventListener('keydown',event=>{
      if(!open)return;
      if(event.key==='Escape'){event.preventDefault();closeMenu(true);return;}
      if(event.key!=='Tab')return;
      const items=focusables();if(!items.length){event.preventDefault();panel&&panel.focus();return;}
      const first=items[0],last=items[items.length-1];
      if(document.activeElement===panel){event.preventDefault();(event.shiftKey?last:first).focus();return;}
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
    window.addEventListener('pageshow',()=>{if(open)closeMenu(false)});
    root.dataset.akgMenuReady='1';
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
